





















































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { usePartnerCardIssueCriteriaStore } from "@/admin/store/partnerCardIssueCriteria";
import { CardEmployerListItem, CreateCardIssueCriteriaRequest } from "@/admin/types";

@Component({
  components: {
    GenericLoadingSpinner,
  },
})
export default class CreateCardIssuanceCriteriaForm extends Vue {
  partnerCardIssueCriteriaStore = usePartnerCardIssueCriteriaStore();

  @Prop() partnerId: string;

  @Prop() employeeForm: boolean;

  employerId = null;
  ssn = null;

  get employerDropDownList (): CardEmployerListItem[] {
    if (this.employeeForm) {
      return this.partnerCardIssueCriteriaStore.allEmployers;
    }
    else {
      return this.partnerCardIssueCriteriaStore.unconfiguredEmployers;
    }
  }

  get partnerIdNum (): number {
    return Number(this.partnerId);
  }

  get ssnValid (): boolean {
    return  /^\d{3}-\d{2}-\d{4}$/.test(this.ssn);
  }

  createCriteria () {
    const request: CreateCardIssueCriteriaRequest = {
      partnerId: this.partnerIdNum,
      employerId: this.employerId,
      ssn: this.ssn,
    };

    this.partnerCardIssueCriteriaStore.createCardIssueCriteria(request)
    .then(() => {
      this.partnerCardIssueCriteriaStore.reloadPartnerCardIssueStore();
    });

    this.employerId = null;
    this.ssn = null;
  }
}
